// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"618e751a","977":"39899276"}[chunkId] + ".chunk.js";
};